import {queryCache, useMutation} from 'react-query';
import {client} from './ApiClient';
import {ICustomer} from '../Helpers/Types';
import { mapServiceUrls } from '../Helpers/Functions';

const applyCouponToCart = ({urls, session, domain, deviceCode, couponUid, couponCode, quantity, cartUid, cartExternalId, cartSourceExternalId}: {urls: any; session: string; domain: string; deviceCode: string; couponCode: string; couponUid?: string; quantity?: number; cartUid: string; cartExternalId: string; cartSourceExternalId: string}) => {
	let params = `${cartUid ? `?cartUid=${cartUid}` : ''}`
	if (cartExternalId)
		params = `${params === '' ? '?' : '&'}externalId=${cartExternalId}`
	
	if (cartSourceExternalId)
		params = `${params === '' ? '?' : '&'}sourceExternalId=${cartSourceExternalId}`
	return client(mapServiceUrls(urls).LoyaltyEngineApiUrl, `api/v4/${domain}/${deviceCode}/snippets/customer/${session}/carts/applycoupon${params}`, {
		body: {
			CouponUid: couponUid,
			CouponCode: couponCode,
			Quantity: quantity ?? null
		}
	});
}

export default function useApplyCouponToCart() {
	// @ts-ignore
	return useMutation(applyCouponToCart)
}